"use client";
import { Comment } from "@prisma/client";
import Button from "@/components/ui/forms/tailwind/Button";
import { useEffect, useState } from "react";

type props = {
  data: Comment;
  handleResolve: ({
    commentId,
    isResolved,
  }: {
    commentId: string;
    isResolved: boolean;
  }) => void;
};

const Resolve = ({ data, handleResolve }: props) => {
  const [resolved, setResolved] = useState(true);

  useEffect(() => {
    setResolved(data.isResolved);
  }, [data.isResolved]);

  const handleClick = () => {
    handleResolve({ commentId: data.id, isResolved: !resolved });
    setResolved(!resolved);
  };

  if (resolved)
    return (
      <Button variant="link" onClick={() => handleClick()} className="mx-4">
        Reabrir debate
      </Button>
    );

  return (
    <Button variant="link" onClick={() => handleClick()} className="mx-4">
      Marcar como resulto
    </Button>
  );
};

export default Resolve;
